import type { ReactNode } from "react";
import { Chip } from "../../../../atoms/Chip";

/**
 * Bordered caption next to a title ("1 of 2"). Part-booked items render each
 * booking as a full peer row, so the tag is what tells them apart.
 *
 * The portal hand-rolled this border on a Typography span; the DS Chip
 * (outlined, sm) is the same box — pill radius, hairline border, quiet label.
 */
export const PartTag = ({ children }: { children: ReactNode }) => (
  <Chip label={children} size="sm" variant="outlined" className="shrink-0" />
);
